<template>
  <div>
    <header class="golge" v-if="!this.$store.getters.Veznedar">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-xl-4 menukutu">
            <a href="#" class="logo"></a>
            <div v-if="Aidatim" class="dropdown">
              <router-link to="/aidatim" class="ustmenu" id="Aidatım" data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false">
                <i class="feather-cpu text-success"></i>
                <small class="menubaslik tx-IBM text-success">AIDATIM</small>
              </router-link>
            </div>
            <div class="dropdown">
              <router-link to="/destek" class="ustmenu" id="Destek">
                <i class="feather-help-circle"></i>
                <small class="menubaslik tx-IBM">DESTEK</small>
              </router-link>
            </div>
            <div class="dropdown" v-if="this.$store.getters.Yetki.entegrasyon>0">
              <a href="#" class="ustmenu" id="Entegrasyon" data-toggle="dropdown" aria-haspopup="true"
                 aria-expanded="false">
                <i class="feather-grid"></i>
                <small class="menubaslik tx-IBM">ENTEGRASYON</small>
              </a>
              <div class="dropdown-menu spesiyalmenu entegrasyon"
                   aria-labelledby="Entegrasyon">
                <a v-if="$store.getters.Paket!=2" @click="SantralEntegrasyonModal=true" class="golgehover"><i
                  class="feather-headphones"></i>
                  <small>SANAL SANTRAL</small>
                </a>
                <a v-if="$store.getters.Paket!=2" @click="SanalPosEntegrasyonModal=true" class="golgehover">
                  <i class="feather-credit-card"></i>
                  <small>SANAL POS</small>
                </a>
                <a @click="BankaEntegrasyonModal=true" class="golgehover">
                  <i class="feather-paperclip"></i>
                  <small>BANKA ENTEGRASYONU</small>
                </a>
                <a @click="WebSite" class="golgehover">
                  <i class="feather-monitor"></i>
                  <small>WEB SİTE</small>
                </a>
              </div>
            </div>
            <div class="dropdown" v-if="this.$store.getters.Admin>0">
              <a href="#" class="ustmenu" id="UstMenuButon" data-toggle="dropdown" aria-haspopup="true"
                 aria-expanded="false"><i class="feather-shield"></i>
                <small class="menubaslik tx-IBM">ADMİN</small>
              </a>
              <div class="dropdown-menu spesiyalmenu" aria-labelledby="UstMenuButon">

                <a @click="SistemAyarlariModal=true" class="golgehover">
                  <i class="feather-settings"></i>
                  <small>SİSTEM AYARLARI</small>
                </a>
                <a @click="HesapModal=true" class="golgehover">
                  <i class="feather-info"></i>
                  <small>HESAP BİLGİLERİ</small>
                </a>
                <router-link to="/matbuu"
                             class="golgehover">
                  <i class="feather-file-text"></i>
                  <small>MATBUU ŞABLONLAR</small>
                </router-link>
                <router-link to="/kullanici" class="golgehover">
                  <i class="feather-users"></i>
                  <small>KULLANICI İŞLEMLERİ</small>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xl-4">
            <Spotlight></Spotlight>
          </div>
          <div class="col-md-4 col-xl-4 text-right spesiyalblok">
            <div class="headsolmenu">
              <router-link v-if="$store.getters.Paket!=2 && $store.getters.Admin>0" to="/sim"
                           class="ustmenu pull-right">
                <i class="feather-compass" style="color:#005238"></i>
                <small class="menubaslik tx-IBM" style="color:#005238">PRO</small>
              </router-link>
              <el-popover
                placement="bottom"
                width="400"
                trigger="click">
                <div class="SanalPos">
                  <ManuelSanalPos></ManuelSanalPos>
                </div>
                <a class="ustmenu pull-right" slot="reference">
                  <i class="feather-credit-card"></i>
                  <small class="menubaslik tx-IBM">POS</small>
                </a>
              </el-popover>
            </div>
            <el-tooltip class="item" effect="dark"
                        :content="HesapSorun"
                        v-if="this.$store.getters.Admin>0 && HesapSorun"
                        placement="bottom">
              <a @click="HesapModal=true" class="ustmenu hesapsorun">
                <i class="el-icon-warning"></i> </a>
            </el-tooltip>
            <a href="#" @click="KanunModal=true" class="ustmenu pull-right"><i class="feather-file-text text-success"></i>
              <small class="menubaslik tx-IBM"></small>
            </a>
            <a href="#" @click="YenilikModal=true" class="ustmenu">
              <i class="feather-slack text-primary"></i>
              <small class="menubaslik tx-IBM"></small>
            </a>
            <!--router-link to="/magaza" class="ustmenu">
              <i class="el-icon-s-shop text-mavi"></i>
              <small class="menubaslik text-mavi">MAĞAZA</small>
            </router-link-->
            <a @click="BinaSecim"
               class="ustmenu bina spmenu">
              <b class="bold tx-IBM"><i class="feather-home"></i> {{ BinaBilgi.Adi }}</b>
              <!--small v-if="BinaBilgi.Site"><i class="el-icon-guide"></i> {{ BinaBilgi.Site.Adi }}
              </small-->
            </a>
          </div>
        </div>
      </div>
    </header>
    <BankaEntegrasyon :Modal="BankaEntegrasyonModal" v-if="BankaEntegrasyonModal"
                      @Modal="BankaEntegrasyonModal=false"></BankaEntegrasyon>
    <SanalPosEntegrasyon v-if="SanalPosEntegrasyonModal" :Modal="SanalPosEntegrasyonModal"
                         @Modal="SanalPosEntegrasyonModal=false"></SanalPosEntegrasyon>
    <SantralEntegrasyon v-if="SantralEntegrasyonModal" :Modal="SantralEntegrasyonModal"
                        @Modal="SantralEntegrasyonModal=false"></SantralEntegrasyon>
    <MailEntegrasyon v-if="MailEntegrasyonModal" :Modal="MailEntegrasyonModal"
                     @Modal="MailEntegrasyonModal=false"></MailEntegrasyon>
    <el-dialog
      v-if="!this.$store.getters.Veznedar"
      title="Bina Seçimi"
      :visible.sync="BinaModal"
      center
      width="30%">
      <a @click="BinaModal = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-select v-model="SeciliBina" @change="BinaSecildi" filterable>
        <el-option-group
          label="BİNALAR">
          <el-option
            v-for="item in BinaListe"
            v-if="!item.Alt"
            :key="item.id"
            :label="item.Adi"
            :value="item.id">
          </el-option>
        </el-option-group>
        <el-option-group
          v-for="item in BinaListe"
          v-if="item.Alt"
          :key="item.id"
          :label="item.Adi">
          <el-option
            v-for="ab in item.Alt"
            :key="ab.id"
            :label="ab.Adi"
            :value="ab.id">
          </el-option>
        </el-option-group>
      </el-select>
      <hr>
      <el-button v-if="this.$store.getters.BinaBilgi" @click="BinaSecimIptal" class="btn-block" type="danger"
                 size="mini">BİNA SEÇİM İPTAL
      </el-button>
    </el-dialog>
    <div class="yanmenu" :class="$store.getters.Paket==2 || $store.getters.Veznedar?'Apartman':'Sirket'"
         id="MenuAkardiyon">
      <router-link to="/panel" tag="div" class="header">

        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 66.2 87.8">
          <path class="st1" fill="#8996a0" d="M27.4,26.8l7.8,6.7c0.9,1.1,1.4,2.2-1.1,3.9l-8,6.3c0,0,22.7,15.4,22.5,15.4
			S52,78.4,50.9,78C50.6,77.9,0.6,44.6,0.6,44.6c-0.6-1.1-0.4-2.5,0.6-3.3L23,26.8C25.5,25,25.9,25.6,27.4,26.8z"/>
          <path class="st2" fill="#8996a0" d="M49.8,14.5l12.3,8.3c2.8,1.7,2.8,3.6,2.8,6.7v54c0,3.1-1.7,2.6-3.1,2.3l-12.5-9
			c-0.7-0.3-1.2-0.5-1.7-2.8V20C47.6,17,46.7,14.5,49.8,14.5z"/>
          <path class="st3" fill="#8996a0" d="M51.2,10.5c-0.6-0.5-0.7-1.4-0.2-2c0.1-0.1,0.1-0.1,0.2-0.2l13.4-8.1C64.8,0.1,65,0,65.2,0
				c0.3,0,0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7v16.8c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.4,0-0.5-0.1L51.2,10.5z"
          />
        </svg>

      </router-link>
      <!--      <div class="golgever"><span></span></div>-->
      <!--      <div class="golgever golgeveralt"><span></span></div>-->
      <div class="footer">
        <div class="dropdown spmenu">
          <a href="#" class="ustmenu kullanici" @click="CikisYap"><b class="bold ">
            <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                 xmlns="http://www.w3.org/2000/svg">
              <g>
                <path
                  d="m240.239 244.407c-11.182 3.625-23.11 5.593-35.5 5.593-63.513 0-115-51.487-115-115s51.487-115 115-115c12.39 0 24.318 1.968 35.5 5.593-46.138 14.961-79.5 58.284-79.5 109.407s33.362 94.446 79.5 109.407zm102.261 187.593v-27c0-33.137 26.863-60 60-60h-60c-33.137 0-60 26.863-60 60v27c0 33.137 26.863 60 60 60h60c-33.137 0-60-26.863-60-60z"
                  fill="#000000" opacity="0.2"/>
                <path
                  d="m437.5 329.361v-26.361c0-33.084-26.916-60-60-60s-60 26.916-60 60v26.022c-31.902 10.524-55 40.596-55 75.978v27c0 44.112 35.888 80 80 80h69c44.112 0 80-35.888 80-80v-27c0-35.011-22.617-64.82-54-75.639zm-80-26.361c0-11.028 8.972-20 20-20s20 8.972 20 20v22h-40zm94 129c0 22.056-17.944 40-40 40h-69c-22.056 0-40-17.944-40-40v-27c0-22.056 17.944-40 40-40h69c22.056 0 40 17.944 40 40zm-101-297c0-74.439-60.561-135-135-135s-135 60.561-135 135 60.561 135 135 135 135-60.561 135-135zm-135 95c-52.383 0-95-42.617-95-95s42.617-95 95-95 95 42.617 95 95-42.617 95-95 95z"
                  fill="#8996a0"/>
                <path
                  d="m40.5 512c-11.046 0-20-8.954-20-20 0-100.355 81.645-182 182-182h20c11.046 0 20 8.954 20 20s-8.954 20-20 20h-20c-78.299 0-142 63.701-142 142 0 11.046-8.954 20-20 20zm336.333-118c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25z"
                  fill="#ffc107"/>
              </g>
            </svg>
          </b>
            <small>{{ this.$store.getters.KullaniciBilgi.KullaniciAdi }}</small>
          </a>
        </div>
      </div>
      <SirketMenu v-if="$store.getters.Paket==1 && !this.$store.getters.Veznedar"></SirketMenu>
      <ApartmanMenu v-if="$store.getters.Paket==2 && !this.$store.getters.Veznedar"></ApartmanMenu>
    </div>
    <Yenilikler :YenilikModal="YenilikModal" v-if="YenilikModal" @YenilikModal="YenilikModal=false"></Yenilikler>
    <SantralCagriIzleme :SantralDurum="SantralDurum"></SantralCagriIzleme>
    <SistemAyarlari v-if="SistemAyarlariModal" @SistemAyarlariModal="SistemAyarlariModal=false"
                    :SistemAyarlariModal="SistemAyarlariModal"></SistemAyarlari>
    <Hesap v-if="HesapModal" @HesapModal="HesapModal=false"
           :HesapModal="HesapModal"></Hesap>
    <Kanunlar v-if="KanunModal" @Modal="KanunModal=false" :Modal="KanunModal"></Kanunlar>
  </div>
</template>

<script>
import SistemAyarlari from "../Pack/Genel/SistemAyarlari";
import Hesap from "../Pack/Genel/Hesap";
import Spotlight from "./Spotlight";
import SirketMenu from "./Menu/SirketMenu";
import BankaEntegrasyon from "../Pack/Entegrasyon/BankaEntegrasyon";
import SanalPosEntegrasyon from "../Pack/Entegrasyon/SanalPosEntegrasyon";
import SantralEntegrasyon from "../Pack/Entegrasyon/SantralEntegrasyon";
import MailEntegrasyon from "../Pack/Entegrasyon/MailEntegrasyon";
import ApartmanMenu from "./Menu/ApartmanMenu";
import SantralCagriIzleme from "../Pack/Entegrasyon/SantralCagriIzleme";
import Yenilikler from "../Pack/Genel/Yenilikler";
import ManuelSanalPos from "../Pack/Vezne/ManuelSanalPos";
import Kanunlar from "../Pack/Spesiyal/Kanunlar";

export default {
  components: {
    Kanunlar,
    Yenilikler,
    SantralCagriIzleme,
    ApartmanMenu,
    MailEntegrasyon,
    SantralEntegrasyon,
    SanalPosEntegrasyon,
    BankaEntegrasyon,
    SirketMenu,
    Spotlight,
    Hesap,
    SistemAyarlari,
    ManuelSanalPos
  },
  data() {
    return {
      SubDomain: '',
      DuyuruDetay: null,
      DestekTalepModal: false,
      KanunModal: false,
      HesapSorun: null,
      HesapModal: false,
      DestekModal: false,
      TeknolojiModal: false,
      SistemAyarlariModal: false,
      BankaEntegrasyonModal: false,
      SanalPosEntegrasyonModal: false,
      MailEntegrasyonModal: false,
      SantralEntegrasyonModal: false,
      BinaModal: false,
      SpotlightStatus: false,
      YenilikModal: false,
      BinaListe: [],
      Bildirimler: [],
      SeciliBina: null,
      Paket: null,
      HesapBilgi: null,
      Proje: null,
      BildirimSay: 0,
      Aidatim: false,
      aienerji: false,
      EkranOlay: false,
      SantralDurum: [],
      BinaBilgi: {
        Adi: null,
        Donem: null
      }
    }
  },
  methods: {

    HesapDenetim() {
      //localStorage.setItem("DuyuruModal", this.DuyuruDetay.stroge)
      if (this.DuyuruDetay) {
        if (localStorage.getItem('DuyuruModal') !== this.DuyuruDetay.stroge && (this.DuyuruDetay.Paket === this.$store.getters.Paket || this.DuyuruDetay.Paket === 0)) {
          this.$alert(this.DuyuruDetay.Text, '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'Kapat ve birdaha gösterme',
          }).then(() => {
            localStorage.setItem("DuyuruModal", this.DuyuruDetay.stroge)
          });
        }
        $(".el-message-box__close.el-icon-close").remove();
        $(".el-message-box__header").remove();
      }
      if (this.HesapBilgi.Mesken.Kalan < 0) {
        this.$alert('Aidatım mesken kredi kotanızı  aştınız. Lütfen mesken kredisi yükleyiniz.<hr>Güncel Mesken Kotanız: <b class="text-kirmizi">' + this.HesapBilgi.Mesken.Kalan + '</b>', 'Mesken Kredisi Kotası.', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Ödeme Yap',
          callback: action => {
            this.HesapModal = true;
          }
        });
        if (this.$route.path !== '/panel') {
          this.$router.push('/panel');
        }
      }
      if (this.HesapBilgi.Sure.Kalan < 0) {

        this.$alert('Aidatım\'ı beğendiğinizi umarız. Ödeme yaparak aboneliğinizi tekrar başlatabilir ve uygulamayı kullanmaya devam edebilirsiniz.', 'Aboneliğiniz Sona Ermiştir.', {
          confirmButtonText: 'Ödeme Yap',
          callback: action => {
            this.HesapModal = true;
          }
        });
        if (this.$route.path !== '/panel') {
          this.$router.push('/panel');
        }
      }
    },
    BinaSecimIptal() {
      this.BinaBilgi.Adi = 'Seçili Bina Yok';
      this.BinaBilgi.Donem = null;
      localStorage.removeItem('_aiBina');
      location.reload();
    },
    BinaSecim() {
      this.$store.dispatch("Get", {path: 'spesiyal/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.BinaListe = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.BinaModal = true;
    },
    BinaSecildi() {
      this.$store.dispatch("Get", {path: 'yonetim/bina/' + this.SeciliBina})
        .then(response => {
          if (response.Durum === 'OK') {
            localStorage.setItem('_aiBina', JSON.stringify(response.Bilgi));
            this.BinaBilgi = response.Bilgi;
            this.$message.success('Bina Seçildi');
            location.reload();
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
    CikisYap() {
      this.$confirm("Oturumu kapatmak istediğinize eminmisiniz?", "Oturum Kapatılacak", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Cikis();
      }).catch(() => {
        this.$message.info("Oturum Kapatılmadı");
      });
    },
    Cikis() {
      this.$store.dispatch("Get", {path: 'spesiyal/cikis', loading: false})
        .then(response => {
          if (response.Durum === 'OK') {
            this.$store.dispatch("logout");
          }
        });
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('_aiLocale', locale);
    },
    Menu() {
      $("body").toggleClass('bodymenu');
      $("body").removeClass('bodyaltmenu');
    },
    SantralKontrol() {
      this.$store.dispatch("Get", {path: 'spesiyal/santralizle/'})
        .then(response => {
          if (response.Durum === 'OK') {
            if (response.Liste) this.SantralDurum.push(response.Liste);
            setTimeout(() => {
              this.SantralKontrol();
            }, 10000);

          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    WebSite() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_web'})
        .then(response => {
          this.lo = false;
          if (response.Durum == 'OK') {
            this.WebYetki = true;
            this.Url = response.Url;

            var w = Number(window.screen.width - 200)
            var h = Number(window.screen.height - 200)
            //console.log(w, h)
            window.open(this.Url, "MsgWindow", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=" + w + ",height=" + h);

          } else {
            this.WebYetki = false;
          }
        })
    },

  },
  created() {
    this.SubDomain = window.location.host.split('.')[0];

    this.Proje = localStorage.getItem('_aiProje');
    if (window.innerWidth > 1366) this.EkranOlay = true
    // window.addEventListener('keyup', event => {
    //   //console.log(event);
    //   if (event.key === "F9") this.BinaModal = true;
    //   if (event.key === "F10") this.HesapModal = true;
    //   //if (event.key === "Alt") this.SistemAyarlariModal = true;
    // });


    if (localStorage.getItem('_airoot')) {
      this.Aidatim = true;
    }
    if (localStorage.getItem('_aienerji')) {
      this.aienerji = true;
    }

    this.$store.dispatch("Get", {path: 'spesiyal/hesapbilgi/'})
      .then(response => {
        if (response.Durum === 'OK') {
          this.HesapBilgi = response.Bilgi;
          if (response.Duyuru) this.DuyuruDetay = response.Duyuru;
          if (this.HesapBilgi) {

            if (this.HesapBilgi.Sms.Kalan > 0 && this.HesapBilgi.Sms.Kalan < 100) this.HesapSorun = 'Sms yüklemeniz gerekmektedir.';
            if (this.HesapBilgi.Sure.Kalan < 15) {
              var text = null;
              if (this.HesapBilgi.Sure.Kalan > 0) text = "Aboneliğiniz " + this.HesapBilgi.Sure.Kalan + " gün sonra sona eriyor."
              if (this.HesapBilgi.Sure.Kalan === 0) text = "Aboneliğiniz bugün sona eriyor."
              if (this.HesapBilgi.Sure.Kalan < 0) {
                text = "Aboneliğiniz sona erdi.";
              }
              this.HesapSorun = text;
              if (this.HesapBilgi.Sure.Kalan < 8) {
                if (Number(localStorage.getItem('_aiHesapSorun')) !== this.HesapBilgi.Sure.Kalan) {
                  this.$alert(text, 'Kritik Bilgilendirme', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'Bilgilendirmeyi Anladım ve Onayladım',
                  }).then(() => {
                    localStorage.setItem("_aiHesapSorun", this.HesapBilgi.Sure.Kalan)
                  });
                  $(".el-message-box__close.el-icon-close").remove();
                }
              }
            }
            if (this.HesapBilgi.Santral) this.SantralKontrol();
          }
          localStorage.setItem("_aiHizmet", JSON.stringify(response.Bilgi));
          if (response.Aidatim) localStorage.setItem("_airoot", JSON.stringify(response.Aidatim));
          if (response.aienerji) localStorage.setItem("_aienerji", JSON.stringify(response.aienerji));
          this.HesapDenetim();
        }
      });
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
    }
    if (!this.BinaBilgi.Adi) {
      this.BinaBilgi.Adi = 'Seçili Bina Yok';
    }
  },

  computed: {
    Denetle() {
      return this.$route.path
    },
  },
  watch: {
    Denetle() {
      this.HesapDenetim();
      $("body").removeClass('bodymenu');

    },
  }
}
</script>

<style scoped>
.hesapsorun {
  position: relative;
  -webkit-animation: flashhover linear 2s infinite;
  animation: flashhover linear 2s infinite;
}

.hesapsorun:hover {
  color: #ea4335 !important;
  background: #fff !important;
  -webkit-animation: flashhover linear 2s infinite;
  animation: flashhover linear 2s infinite;
}

.hesapsorun i {
  font-size: 16px;
  position: relative;
  top: 0px;
}

@-webkit-keyframes flash {
  0% {
    background: #ea4335;
  }
  50% {
    background: #333333;
  }
  100% {
    background: #ea4335;
  }
}

@keyframes flash {
  0% {
    background: #ea4335;
  }
  50% {
    background: #333333;
  }
  100% {
    background: #ea4335;
  }
}

@-webkit-keyframes flashhover {
  0% {
    color: #ea4335;
  }
  50% {
    color: #333333;
  }
  100% {
    color: #ea4335;
  }
}

@keyframes flashhover {
  0% {
    color: #ea4335;
  }
  50% {
    color: #333333;
  }
  100% {
    color: #ea4335;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/Header.vue